import React, { useState, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';

export default function MapPicker({ maps, onAdd }) {
  const [input, setInput] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const elRef = useRef();

  const lowerInput = input.toLowerCase();
  const matching = maps
    ? maps.filter(m => m.name.toLowerCase().includes(lowerInput) || m.label?.toLowerCase().includes(lowerInput))
    : [];
  const nonMatching = maps ? maps.filter(m => !matching.includes(m)) : [];

  function commitAdd(name) {
    if (!name.trim()) return;
    onAdd(name.trim());
    setInput('');
    setShowSuggestions(false);
  }

  function handleInputChange(e) {
    setInput(e.target.value);
    setShowSuggestions(true);
  }

  function handleInputClick() {
    setShowSuggestions(true);
  }

  function handleChevronClick() {
    setShowSuggestions(prev => !prev);
  }

  function handleBlur() {
    if (elRef.current && !elRef.current.contains(document.activeElement)) {
      setShowSuggestions(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape') {
      setShowSuggestions(false);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const firstMatch = matching[0];
      commitAdd(firstMatch ? firstMatch.name : input);
    }
  }

  return (
    <div className='relative' ref={elRef}>
      <div className='flex relative w-48'>
        <input
          className='rounded-r-none flex-grow'
          type='text'
          value={input}
          onChange={handleInputChange}
          onClick={handleInputClick}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          placeholder='Search maps…'
          autoComplete='off'
        />
        <button
          type='button'
          className='flex items-center px-2 text-gray-400 hover:text-gray-200 rounded-l-none'
          onClick={handleChevronClick}
          onBlur={handleBlur}
          tabIndex={-1}
        >
          <FaChevronDown />
        </button>
      </div>

      {showSuggestions && (
        <ul className='absolute z-10 bg-white border border-gray-300 w-48 max-h-60 overflow-y-auto'>
          {matching.map(m => (
            <li
              key={m.name}
              className='p-1 cursor-pointer hover:bg-gray-400'
              onMouseDown={(e) => { e.preventDefault(); commitAdd(m.name); }}
              tabIndex='0'
            >
              {m.label || m.name}
            </li>
          ))}
          {nonMatching.map(m => (
            <li
              key={m.name}
              className='p-1 cursor-pointer hover:bg-gray-200 text-gray-400'
              onMouseDown={(e) => { e.preventDefault(); commitAdd(m.name); }}
              tabIndex='0'
            >
              {m.label || m.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
